exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a.policy[data-v-1dcdb75c]{color:#00ba57}a.policy-disabled[data-v-1dcdb75c]{color:#858585}p.text-black[data-v-1dcdb75c]{color:#000}p.text-red[data-v-1dcdb75c]{color:#ff5252}p.text-yellow[data-v-1dcdb75c]{color:#b7b708}p.text-green[data-v-1dcdb75c]{color:#00ba57}p.alert-text[data-v-1dcdb75c]{white-space:pre-wrap;font-size:14px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1dcdb75c","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/fields/ToDoc.vue
// module id = ucRz
// module chunks = 0 1